import { Environment } from '../environment';

const isDev = Environment.IS_DEV || window.localStorage.getItem('IS_DEV');

export const utilLog = isDev ? Function.prototype.bind.call(console.log, [], '[DEBUG]') : () => {};
